import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import styles from './style.scss';


const SubscriptionIcon = ({ width, height, type, extraClassName }) => {
  const style = {
    width: width ? `${width}px` : null,
    height: height ? `${height}px` : null,
  };
  const themeList = {
    // Как премиум !? Когда везде фигурирует pro, standard and audio!
    premium: 'themePremium',
    pro: 'themePremium',
    audio: 'themePremium',
    standard: 'themeStandard',
    free: 'themeFree',
    standardChecked: 'themeStandardChecked',
    premiumChecked: 'themePremiumChecked',
  };

  return (
    <span
      className={classNames(styles.subscriptionIcon, themeList[type], extraClassName)}
      style={style} />
  );
};

SubscriptionIcon.propTypes = {
  width: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.number,
  ]),
  height: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.number,
  ]),
  type: PropTypes.string.isRequired,
  extraClassName: PropTypes.string,
};

SubscriptionIcon.defaultProps = {
  width: null,
  height: null,
  extraClassName: '',
};

export default SubscriptionIcon;
